import React from "react";
import { CheckCircleFilled, WarningFilled } from "@ant-design/icons";
import { Tooltip } from "antd";
import SecurePassLabel from "@/components/SecurePass/SecurePassLabel/SecurePassLabel";

const SecurePassAddressSetting = ({ autoSendSecurePassLevel, contactEmail }) => {
  const emails = contactEmail?.split(",");
  return (
    <>
      <span className="span-click">
        SecurePass:{" "}
        <b>
          <SecurePassLabel securePassValue={autoSendSecurePassLevel} />{" "}
        </b>
      </span>
      <br />
      {contactEmail ? (
        <>
          <span>
            Contact:{" "}
            <b>
              <Tooltip
                color="white"
                title={
                  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    {emails?.map(email => (
                      <li key={email}>{email}</li>
                    ))}
                  </ul>
                }
              >
                {`${emails?.length} ${emails?.length > 1 ? "emails" : "email"} set`}
              </Tooltip>
            </b>
          </span>
          <CheckCircleFilled style={{ color: "#52c41a", marginLeft: 5 }} />
        </>
      ) : (
        <>
          <span>
            Contact: <b>Not Set</b>
          </span>
          <WarningFilled style={{ color: "#faad14", marginLeft: 5 }} />
        </>
      )}
    </>
  );
};

export default SecurePassAddressSetting;
